import { Stack, Tab, Tabs } from '@mui/material';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { a11yProps, TabPanel } from '../../../../component/TabPanel';
import { GroupFeatureList } from './GroupFeatureList';
import { GroupObjectList } from './GroupObjectList';
import { ClassificationContext } from '../../context/ClassificationContext.types';

enum GroupDetailTabs {
  FeatureList,
  ObjectList,
}

export function GroupDetail() {
  const { selectedGroup } = useContext(ClassificationContext);

  const [value, setValue] = useState(GroupDetailTabs.FeatureList);

  const { t } = useTranslation();
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  if (!selectedGroup) return null;

  return (
    <Stack>
      <Tabs aria-label="basic tabs merge" value={value} onChange={handleChange}>
        <Tab label={t('classification.groups.tabs.features')} {...a11yProps(0)} />
        <Tab label={t('classification.groups.tabs.assignedObjects')} {...a11yProps(1)} />
      </Tabs>
      <TabPanel value={value} index={GroupDetailTabs.FeatureList}>
        <GroupFeatureList />
      </TabPanel>
      <TabPanel value={value} index={GroupDetailTabs.ObjectList}>
        <GroupObjectList />
      </TabPanel>
    </Stack>
  );
}
